import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute.js';
import AdminRoute from './AdminRoute.js';
import { LoadingSpinner } from '../components/feedback/index.js';
import UserAnalytics from '../pages/UserAnalytics.js';
import CompanyDrilldown from '../pages/CompanyDrilldown.js';
import ProfilePage from '../pages/ProfilePage.js';
import AccountPage from '../pages/AccountPage.js';
import ApiDocsPage from '../pages/ApiDocsPage.js';
import ApiKeysPage from '../pages/ApiKeysPage.js';
import ForbiddenPage from '../pages/ForbiddenPage.js';
import NotFoundPage from '../pages/NotFoundPage.js';
import VoiceDemoPage from '../pages/VoiceDemoPage.js';
import LogsPage from '../pages/LogsPage.js';

// Loading fallback for routes
const PageLoadingFallback: React.FC = () => (
  <div className="min-h-[50vh] flex items-center justify-center">
    <LoadingSpinner size="lg" label="Loading page..." />
  </div>
);

const AppRoutes: React.FC = () => (
  <Suspense fallback={<PageLoadingFallback />}>
    <Routes>
      {/* Dashboard is the default route, protected by auth */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <UserAnalytics />
          </PrivateRoute>
        }
      />
      {/* Redirect /dashboard to / for backwards compatibility */}
      <Route path="/dashboard" element={<Navigate to="/" replace />} />
      {/* Company drill-down (sc-43503) — reached from the Company overview table. */}
      <Route
        path="/companies/:companyId"
        element={
          <PrivateRoute>
            <CompanyDrilldown />
          </PrivateRoute>
        }
      />
      <Route path="/403" element={<ForbiddenPage />} />
      <Route
        path="/logs"
        element={
          <PrivateRoute>
            <LogsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/account"
        element={
          <PrivateRoute>
            <AccountPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <ProfilePage />
          </PrivateRoute>
        }
      />
      <Route
        path="/api-docs"
        element={
          <PrivateRoute>
            <ApiDocsPage />
          </PrivateRoute>
        }
      />
      {/* AC1 (sc-45102): AceUp/Partner Admins only — AdminRoute redirects
          everyone else to /403, same guard as Team Management. */}
      <Route
        path="/api-keys"
        element={
          <AdminRoute>
            <ApiKeysPage />
          </AdminRoute>
        }
      />
      <Route
        path="/voice-demo"
        element={
          <PrivateRoute>
            <VoiceDemoPage />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </Suspense>
);

export default AppRoutes;
